import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import Header from "../components/Header";
import ByHour, { ByHourRef } from "./ByHour";
import { useFilter } from "../context/FilterContext";

const Home: React.FC = () => {
  // Use FilterContext instead of local state
  const { activeTab, setActiveTab, getFilterState, updateFilterState } =
    useFilter();

  // Refs for components that support refresh
  const byHourRef = useRef<ByHourRef>(null);

  // Simplified filter change handler using context
  const handleFilterChange = (
    isRefresh: boolean,
    startDate: string | null,
    endDate: string | null,
    filter: string | null,
    pageNum?: number,
    limitNum?: number,
    quotedJobcode?: string | null,
    techLdap?: string | null,
    acctgDt?: string | null,
    declineReason?: string | null,
    applianceType?: string | null,
    createSource?: string | null,
    llmChatClassification?: string | null,
    orderNumber?: string | null,
    customerRating?: string | null,
  ) => {
    const currentState = getFilterState(activeTab);
    updateFilterState(activeTab, {
      startDate: startDate !== undefined ? startDate : currentState.startDate,
      endDate: endDate !== undefined ? endDate : currentState.endDate,
      filter: filter !== null ? filter : "",
      quotedJobcode:
        quotedJobcode !== undefined && quotedJobcode !== null
          ? quotedJobcode
          : currentState.quotedJobcode,
      techLdap:
        techLdap !== undefined && techLdap !== null
          ? techLdap
          : currentState.techLdap,
      acctgDt:
        acctgDt !== undefined && acctgDt !== null
          ? acctgDt
          : currentState.acctgDt,
      declineReason:
        declineReason !== undefined && declineReason !== null
          ? declineReason
          : currentState.declineReason,
      applianceType:
        applianceType !== undefined && applianceType !== null
          ? applianceType
          : currentState.applianceType,
      createSource:
        createSource !== undefined && createSource !== null
          ? createSource
          : currentState.createSource,
      llmChatClassification:
        llmChatClassification !== undefined && llmChatClassification !== null
          ? llmChatClassification
          : currentState.llmChatClassification,
      orderNumber:
        orderNumber !== undefined && orderNumber !== null
          ? orderNumber
          : currentState.orderNumber,
      customerRating:
        customerRating !== undefined && customerRating !== null
          ? customerRating
          : currentState.customerRating,
      page: pageNum !== undefined ? pageNum : currentState.page,
      limit: limitNum !== undefined ? limitNum : currentState.limit,
    });
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleRefresh = () => {
    byHourRef.current?.refresh();
  };

  const renderTabContent = () => {
    const filterState = getFilterState(activeTab);
    return (
      <ByHour
        ref={byHourRef}
        filterState={filterState}
        onFilterChange={handleFilterChange}
      />
    );
  };

  return (
    <Box>
      <Header
        activeTab={activeTab}
        onTabChange={handleTabChange}
        onRefresh={handleRefresh}
      />
      {renderTabContent()}
    </Box>
  );
};

export default Home;
